const PENDING_CALLS = {};

function call(data, method='POST') {
    return $.ajax({
        url: '/coaching_schedule/schedule_api_functions.php',
        method,
        dataType: 'json',
        data
    });
}

function queueIt(func, storeBy=[]) {
    const getKey = (data) => storeBy.reduce((prev, next) => `${prev}.${data[next]}`, '');
    const queue = {};

    return function() {
        const key = getKey(arguments[0]);

        if (queue[key] && queue[key].id) {
            clearTimeout(queue[key].id);
        }

        queue[key] = { id: null, args: arguments };

        queue[key].id = setTimeout(() => {
            func.apply(null, queue[key].args);
            queue[key].id = null;
        }, 2000);
    }
}

export default class Api {
    constructor(key) {
        this.key = key;

        this.saveField = queueIt(this._saveField, ['id','field']);
        this.saveNotes = queueIt(this._saveNotes, ['note']);
    }

    load = () => {
        return call({
            method: 'getSchedule',
            key: this.key
        }, 'GET');
    }

    saveFields = ({ id, fields }) => {
        return call({
            method: 'saveTeacherFields',
            id,
            fields,
            key: this.key
        });
    }

    _saveField = ({ id, field, value }) => {
        return call({
            method: 'saveTeacherField',
            id,
            field,
            value,
            key: this.key
        });
    }

    _saveNotes = ({ note }) => {
        return call({
            method: 'saveNote',
            key: this.key,
            note
        });
    }

    createTeacher = (success, error) => {
        return call({
            method: 'createTeacher',
            key: this.key
        });
    }

    removeTeacher = (id) => {
        return call({
            method: 'deleteTeacher',
            id,
            key: this.key
        });
    }

    removeAllTeachers = (success, error) => {
        return call({
            method: 'deleteAllTeachers',
            key: this.key
        });
    }
}
